import React from 'react';
import { FadeIn } from './Shared';
import { Scale } from 'lucide-react';
export const CostComparison = () => {
  return <section className="py-16 md:py-24 px-4 bg-navy-900/30 relative overflow-hidden pt-[32px] pb-[32px]" data-id="element-47">
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-48">
        <FadeIn data-id="element-49">
          <div className="text-center mb-16" data-id="element-50">
            <div className="inline-flex items-center justify-center bg-pink-500/10 px-4 py-2 rounded-full border border-pink-500/20 mb-6" data-id="element-51">
              <Scale className="w-6 h-6 text-pink-400 mr-3" data-id="element-52" />
              <span className="text-pink-400 font-bold tracking-[0.2em] text-xs uppercase" data-id="element-53">
                LA BALANZA
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl text-white mb-6 leading-tight font-[900] font-[Montserrat,_sans-serif]" data-id="element-54">
              ⚖️ ¿CUÁNTO CUESTA NO TENERLO?
            </h2>
          </div>

          <div className="bg-navy-950 rounded-3xl border border-white/10 overflow-hidden" data-id="element-55">
            <div className="w-full" data-id="element-56">
              {/* Header */}
              <div className="grid grid-cols-2 bg-navy-900 border-b border-white/10" data-id="element-57">
                <div className="py-4 md:py-8 px-4 md:px-8 text-red-400 font-bold text-[10px] md:text-sm uppercase tracking-widest border-r border-white/5 flex items-center" data-id="element-58">
                  Sin Método Caja Ordenada
                </div>
                <div className="py-4 md:py-8 px-4 md:px-8 text-pink-400 font-bold text-[10px] md:text-sm uppercase tracking-widest flex items-center" data-id="element-59">
                  Costo real
                </div>
              </div>

              {/* Body */}
              <div className="divide-y divide-white/5" data-id="element-60">
                {[['Cada seña que gastás antes de que el pedido cierre', 'Plata comprometida que no podés usar y que no es tuya todavía'], ['Separar sin seña para una clienta que nunca retira', 'Stock inmovilizado + venta perdida a alguien que sí iba a pagar'], ['Vender por Instagram algo ya separado en el showroom', 'Conflicto con dos clientas + producto que no podés entregar a ninguna'], ['Cobrar sin verificar el comprobante', 'Mercadería entregada sin cobrar que puede no cobrar nunca'], ['No registrar los pedidos fuera del chat', 'Datos incompletos, talle equivocado, cliente insatisfecha, reputación dañada'], ['Cerrar la semana sin saber cuánto ganaste', 'Decisiones de reposición a ciegas y sueldo que "sale de lo que sobra"'], ['Stock dormido que nadie activa', 'Capital inmovilizado que podría ser tu próxima colección'], ['Clientas que compraron una vez y no volvieron', 'Una base de contactos con enorme potencial que duerme en tu celular']].map(([sin, costo], i) => <div key={i} className="grid grid-cols-2 transition-colors hover:bg-white/[0.02]" data-id="element-61">
                    <div className="py-4 md:py-6 px-4 md:px-8 text-gray-300 border-r border-white/5 font-medium font-sans text-xs md:text-base leading-relaxed flex items-center" data-id="element-62">
                      {sin}
                    </div>
                    <div className="py-4 md:py-6 px-4 md:px-8 text-gray-100 font-sans font-medium text-xs md:text-lg leading-relaxed flex items-center" data-id="element-63">
                      {costo}
                    </div>
                  </div>)}
              </div>

              {/* Footer */}
              <div className="bg-navy-900/80 border-t-2 border-pink-500/30 py-8 md:py-12 px-6 md:px-8 text-center" data-id="element-64">
                <span className="text-lg md:text-2xl font-bold text-white leading-tight font-[Montserrat,_sans-serif] block mb-4" data-id="element-65">
                  La próxima clienta que te escriba "¿tenés en azul talle M?"
                  puede terminar en un pedido registrado, una seña cobrada y una
                  entrega sin errores.
                </span>
                <span className="text-lg md:text-2xl font-bold text-gray-400 leading-tight font-[Montserrat,_sans-serif] block mb-6" data-id="element-66">
                  O puede terminar en otro pedido flotando en el chat que nadie
                  sabe si existe.
                </span>
                <span className="text-xl md:text-4xl font-black text-pink-400 leading-tight font-[Montserrat,_sans-serif] uppercase block" data-id="element-67">
                  La diferencia es tener el sistema.
                </span>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};